import { useState } from "react";
import styled from "styled-components";

export default function QuestionAssetInputMode({
  asset,
  onModeChange,
  children,
}) {
  const [mode, setMode] = useState(() =>
    !asset.source_code?.trim() && asset.url?.trim() ? "url" : "code",
  );
  const control = (
    <ModeSelect>
      <span>素材類型</span>
      <select
        aria-label="素材類型"
        value={mode}
        onChange={(event) => {
          setMode(event.target.value);
          onModeChange?.(event.target.value);
        }}
      >
        <option value="code">程式碼</option>
        <option value="url">圖片 URL</option>
      </select>
    </ModeSelect>
  );
  return children(mode, control);
}

export function QuestionAssetRoleButtons({ value, onChange }) {
  return (
    <ModeBar role="group" aria-label="圖片位置">
      {[
        ["prompt", "題目"],
        ["answer", "答案"],
        ["solution", "詳解"],
      ].map(([role, label]) => (
        <ModeButton
          key={role}
          type="button"
          aria-pressed={value === role}
          onClick={() => onChange(role)}
        >
          {label}
        </ModeButton>
      ))}
    </ModeBar>
  );
}

const ModeSelect = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--app-subtle-text, #3c4043);
  font-size: 13px;
  font-weight: 600;
  select {
    width: 120px;
    padding: 8px 10px;
    border: 1px solid var(--app-border, #d5d7db);
    border-radius: 6px;
    color: var(--app-input-text, #202124);
    background: var(--app-input-bg, #fff);
    font: inherit;
  }
`;

const ModeBar = styled.div`
  display: flex;
  width: fit-content;
  gap: 4px;
  padding: 4px;
  margin: 16px 18px 0;
  border: 1px solid var(--app-border, #e1e5eb);
  border-radius: 9px;
  background: var(--app-surface-hover, #f1f4f8);
`;
const ModeButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px 16px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--app-muted-text, #64748b);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &[aria-pressed="true"] {
    background: var(--app-input-bg, #fff);
    color: var(--app-text, #263348);
    box-shadow: 0 1px 4px rgb(20 35 55 / 12%);
  }
  &:focus-visible {
    outline: 2px solid var(--app-primary, #2563eb);
    outline-offset: 2px;
  }
`;
